import { AuthenticatedRoute, UnauthenticatedRoute } from 'components/Route';
import React, { useContext, useEffect } from 'react';
import { Switch, useLocation } from 'react-router';
import { GlobalContext } from 'utilities/GlobalContext';
import { useSelector } from 'react-redux';
import AudioExercises from './AudioExercise/AudioExercise';
import Flash from './Flash/Flash';
import Home from './Home/Home';
import TestAudio from './TestAudio/TestAudio';
import Homework from './Homework/Homework';
import Login from './Login/Login';
import Test from './Test/Test';
import AdminError from './AdminError/AdminError';

export default function Routes() {
    const { pathname } = useLocation();
    const { setKeyboardIsOpen } = useContext(GlobalContext);

    useEffect(() => setKeyboardIsOpen(false), [pathname]);
    const user = useSelector((store: ReduxStore) => store.authentication?.user);

    return (
        <Switch>
            <UnauthenticatedRoute
                exact
                path="/testaudio"
                component={TestAudio}
            />
            <UnauthenticatedRoute exact path="/test-pagina" component={Test} />
            <AuthenticatedRoute
                exact
                path="/"
                component={user?.role === 'student' ? Home : AdminError}
            />
            <UnauthenticatedRoute exact path="/inloggen" component={Login} />
            <AuthenticatedRoute
                exact
                path="/:treatmentId/homework/:homeworkId"
                // We use the render method with a key prop to disable state persistance on navigation
                render={(props: any) => (
                    <Homework key={props.match.params.homeworkId || 'empty'} />
                )}
            />
            <AuthenticatedRoute
                exact
                path="/:treatmentId/audio-exercise/:exerciseId"
                render={(props: any) => (
                    <AudioExercises
                        key={props.match.params.exerciseId || 'empty'}
                    />
                )}
            />
            <AuthenticatedRoute
                exact
                path="/:treatmentId/flitsprogramma/:exerciseId"
                render={(props: any) => (
                    <Flash key={props.match.params.exerciseId || 'empty'} />
                )}
            />
        </Switch>
    );
}
